import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import pdf from '../assets/Nutrition Levels view.pdf';
import './PdfViewer6.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import Download from '../assets/04 Nutrition levels.pdf';


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function PdfViewer4({ onClose }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = Download;
    link.download = "04 Nutrition levels.pdf";
    link.rel = "noopener noreferrer";
    link.click();
  }
  

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div className="pdfViewer">
      <div className="pdfViewerHeader">
        <button className="closeButton" onClick={onClose}>Close</button>
        <button className="downloadButton" onClick={handleDownload}>Download PDF</button>
      </div>
      <div className="pdfContainer">
  <div className="pageControls">
    <button className='prev' disabled={pageNumber <= 1} onClick={() => setPageNumber(pageNumber - 1)}>Prev</button>
    <span>Page {pageNumber} of {numPages}</span>
    <button className='next' disabled={pageNumber >= numPages} onClick={() => setPageNumber(pageNumber + 1)}>Next</button>
  </div>
  <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess}>
    <Page pageNumber={pageNumber} />
  </Document>

</div>

    </div>
  );
}

export default PdfViewer4;
